import { render, staticRenderFns } from "./SelectApi.vue?vue&type=template&id=5f4dfce5&"
import script from "./SelectApi.vue?vue&type=script&lang=js&"
export * from "./SelectApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports